import { getFallbackLocale } from "../domain/swarovski-optik/locales";
import React, { useEffect, useState } from "react";
import { useStore } from "../store/hooks/use-store";
import { SwarovskiOptikLocale } from "@swo/shared";
import { LocalizedFallbackRoute } from "./localized-fallback-route";
import { storefrontClient } from "../domain/storefront";
import { useFetchedConstant } from "../hooks";
import { fallbackNotFoundTranslations } from "./fallback-route";
import { AppView } from "../styles/AppView";

export function MainRoute() {
  // This component handles redirect to a specific locale (country-language pair) when `/` path is accessed
  const store = useStore();
  const [preferredLocale, setPreferredLocale] = useState<null | SwarovskiOptikLocale>(null);
  const locales = useFetchedConstant(() => storefrontClient.getLocales());

  useEffect(() => {
    if (locales.__tag === "loaded") {
      const preferredLocale =
        locales.data.locales.find(locale => locale.code === store.state.userPreferredLocale) ||
        getFallbackLocale(locales.data.locales, locales.data.fallbackLocaleCode);

      setPreferredLocale(preferredLocale);
    }
  }, [locales.__tag]);

  useEffect(() => {
    if (preferredLocale) {
      // TODO: Make sure this automatic choice is persisted
      if (store.state.userPreferredLocale !== preferredLocale.code) {
        store.dispatch({ type: "set-user-preferred-locale", value: preferredLocale.code });
      }
    }
  }, [preferredLocale]);

  if (!preferredLocale) {
    return null;
  } else {
    return (
      <AppView>
        <LocalizedFallbackRoute locale={preferredLocale} notFoundPageTranslations={fallbackNotFoundTranslations} />
      </AppView>
    );
  }
}
